/* eslint-disable radix */
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import CustomModal from "../../../Core/Components/Modal/CustomModal";
import CustomRoundedImage from "../../../Core/Components/CustomRoundedImage";
import { TrashSecondaryIcon } from "../../../Common/Svgs/TrashIcon";
import CloseIcon from "../../../Common/Svgs/CloseIcon";
import Button from "../../../Core/Components/CustomButton";
import LocationsModuleIcon from "../../../Common/Svgs/LocationsModuleIcon";
import {
  deleteLocationV3,
  getAllLocationsV3,
  getLocationsV3,
} from "../../../Redux/APIs/locationsAPI";
import { updateLocations } from "../../../Redux/Slices/locations.slice";

const LOCAL_DEFAULT_LIMIT = 10;

const DeleteLocationModal = ({
  visible,
  onCancel,
  currentPage,
  setCurrentPage,
}) => {
  const dispatch = useDispatch();

  const { deleteLocationModal } = useSelector((state) => state.locations);

  const onConfirm = async () => {
    await dispatch(
      deleteLocationV3({ locationId: deleteLocationModal?.location.id }),
    );

    const response = await dispatch(
      getLocationsV3({
        offset: ((currentPage || 1) - 1) * LOCAL_DEFAULT_LIMIT,
        limit: LOCAL_DEFAULT_LIMIT,
      }),
    );

    // If no records exist for the current page, move to the previous page
    if (!response.payload.result.length && currentPage > 1) {
      const previousPage = currentPage - 1;
      setCurrentPage(previousPage);

      await dispatch(
        getLocationsV3({
          offset: (previousPage - 1) * LOCAL_DEFAULT_LIMIT,
          limit: LOCAL_DEFAULT_LIMIT,
        }),
      );
    }

    dispatch(getAllLocationsV3());

    await dispatch(
      updateLocations({
        key: "showToastMessage",
        value: {
          visible: true,
          data: {
            title: "1 Location Deleted",
            description: `${
              deleteLocationModal?.location?.name || "1 location"
            } was deleted sucessfully.`,
          },
        },
      }),
    );

    onCancel();
  };

  return (
    <CustomModal visible={visible} onCancel={onCancel} width="536px" centered>
      <div className="w-full p-4 rounded-md">
        <div className="flex items-center justify-between">
          <div className="relative">
            <div className="absolute top-0 right-0">
              <TrashSecondaryIcon className="text-alert-red" />
            </div>
            <CustomRoundedImage
              size="w-12 h-12"
              image={<LocationsModuleIcon className="text-white" />}
              background="bg-primary"
            />
          </div>
          <button type="button" onClick={onCancel}>
            <CloseIcon className="w-6 h-6 stroke-dark-gray" />
          </button>
        </div>
        <div className="px-2 mt-5">
          <p className="text-base font-medium text-alert-red font-poppins">
            Delete location
          </p>
          <p className="mt-2 text-xs font-normal text-black font-aileron">
            Are you sure you want to delete this location from the system?
          </p>
          <p className="mt-2 text-xs font-normal text-black font-aileron">
            This action cannot be undone.
          </p>
        </div>
        <div className="flex justify-end gap-x-3 mt-5.5">
          <Button colors="cancelButton" size="primary" onClick={onCancel}>
            Cancel
          </Button>
          <Button colors="alert" size="primary" onClick={onConfirm}>
            Confirm
          </Button>
        </div>
      </div>
    </CustomModal>
  );
};

export default DeleteLocationModal;
